import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Select from 'react-select';
import { ModalActions } from "redux/actions/ModalActions";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { ModalType } from "models/ModalData";
import { ChangePasswordData, UserActions } from "redux/actions/settings/UserActions";
import { UserRole } from "models/UserRole";
import { RoleActions } from "redux/actions/RoleActions";
import { User } from "models/User";
import Translator from "app/components/common/Translator";
import { Translations } from "models/Translations";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { Translate } from "infrastructure/mapping/Translate";
import { withRouter } from "app/components/common/WithRouter";

interface Props {
    actions: any;
    loginUser: LoginUser;
    users: User[];
    roles: UserRole[];
    translations: Translations;
    changePasswordModal: typeof ModalActions.showModal;
    // changePasswordAction: typeof UserActions.changePassword;
    fetchRoles: typeof RoleActions.fetchRoles;
    fetchUsers: typeof UserActions.fetchAllUserData;
    addRole: typeof UserActions.addRole;
    removeRole: typeof UserActions.removeRole;
    addUser: typeof UserActions.addUser;
    match: UrlParams;
}

interface UrlParams {
    params: {
        id?: number;
    }
}

interface IState {
    selectedOption: SelectedOption | null;
    userData: User;
}

type SelectedOption = {
    label: string,
    value: string
}

class AccountDetailsComp extends React.Component<Props, IState> {
    public readonly state: IState = {
        selectedOption: { label: "", value: "" },
        userData: User.empty()
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    getEditUser() {
        return this.props.match.params.id ? this.props.users[this.props.match.params.id!] : undefined;
    }

    componentDidMount() {
        if (this.loggedIn() && this.props.match.params.id && !this.props.users) {
            this.props.fetchUsers(this.props.loginUser.token);
        }
        if (this.loggedIn() && !this.props.roles) {
            this.props.fetchRoles(this.props.loginUser.token);
        }
    }

    changePassword() {
        const pwdDat: ChangePasswordData = { newPassword: '', confirmNewPassword: '', oldPassword: '' };
        this.props.changePasswordModal({
            isActive: true,
            type: ModalType.FORM,
            header: "Change Password",
            formObject: pwdDat,
            callBack: this.props.addRole
        });
    }

    handleEdit(e: React.FormEvent<HTMLInputElement>, fieldName: string) {
        const newValue = e.currentTarget.value;
        let obj = this.state.userData;
        let formData = this.setValueOnObject(obj, newValue, fieldName);
        this.setState({
            userData: formData as User
        });
    }

    setValueOnObject(obj: object, newValue: string | object | Date, name: string) {
        let newObj = Object.assign({}, obj);
        for (const [key, value] of Object.entries(obj)) {
            if (key === name) {
                if (value instanceof Date) {
                    newValue = new Date(newValue as string)
                }
                newObj = { ...newObj, [key]: newValue };
            }
        }
        return newObj;
    }

    handleSelect(selectedOption: SelectedOption) {
        this.setState({ selectedOption: selectedOption });
    }

    addRole(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        e.stopPropagation();
        if (this.getEditUser()) {
            this.props.addRole(this.props.loginUser.token, { roleId: this.state.selectedOption!.value, userEMail: this.getEditUser()!.email })
        } else {
            this.setState(prevState => {
                let newUserData = { ...prevState.userData };
                const roleId = this.state.selectedOption!.value;
                newUserData.roles.push(new UserRole(roleId, this.props.roles.find(r => r.id === roleId)!.name));
                return { ...prevState, userData: newUserData, selectedOption: { label: "", value: "" } }
            })
        }

    }

    removeRole(e: React.MouseEvent<HTMLButtonElement>, roleId: string) {
        e.preventDefault();
        e.stopPropagation();
        if (this.getEditUser()) {
            this.props.removeRole(this.props.loginUser.token, { roleId: roleId, userEMail: this.getEditUser()!.email })
        } else {
            this.setState(prevState => {
                let newUserData = { ...prevState.userData };
                newUserData.roles = newUserData.roles.filter(ur => ur.id !== roleId)
                return { ...prevState, userData: newUserData }
            })
        }
    }

    submitUser(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.props.addUser(this.props.loginUser.token, this.state.userData);
    }

    ready() {
        if (this.props.loginUser && this.props.roles) {
            if (!this.props.match.params.id) {
                return true
            } else {
                if (this.props.users) {
                    return true
                }
            }
        }
        return false;
    }

    getOptions(setRoles: UserRole[] | undefined) {
        const availableRoles = this.props.roles.filter(r => !setRoles?.find(ur => ur.id === r.id));
        return availableRoles.map(role => {
            return {
                value: role.id,
                label: Translate.text(this.props.translations, role.name)
            }
        })
    }

    getRolesForUser() {
        if (this.getEditUser()) {
            return this.getEditUser()?.roles;
        } else {
            return this.state.userData.roles;
        }
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="User Details" />
                    <Translator text="Loading" />
                </div>
            )
        }
        let setRoles = this.getRolesForUser();
        let options = this.getOptions(setRoles);
        return (
            <div className="c-page__content">
                <PageContentHeader text="User Details" />
                <div className="c-card">
                    <form className="c-form" onSubmit={(e) => this.submitUser(e)}>
                        <div className="c-form__group">
                            <div className="c-form__label">Email:</div>
                            <input type="text" className="c-form__control" disabled={!!this.getEditUser()} value={this.getEditUser()?.email} onChange={(e) => this.handleEdit(e, "email")} />
                        </div>
                        <div className="c-form__group">
                            <div className="c-form__label">Username:</div>
                            <input type="text" className="c-form__control" disabled={!!this.getEditUser()} value={this.getEditUser()?.userName} onChange={(e) => this.handleEdit(e, "userName")} />
                        </div>
                        {/* <div className="c-form__group">
                                    <div className="c-form__label">Password:</div>
                                    <input type="button" className="c-button c-form__control" onClick={this.changePassword.bind(this)} value="Change Password" />
                                </div> */}
                        <div className="c-form__sub-form">
                            <div className="c-form__label"><Translator text="Roles:" /></div>
                            {setRoles?.map(role => {
                                return (
                                    <div className="c-form__group" key={role.id}>
                                        <div className="c-form__label"><Translator text={role.name} /></div>
                                        <button className='c-button c-form__control' onClick={(e) => this.removeRole(e, role.id)}>
                                            <Translator text="Remove" />
                                        </button>
                                    </div>
                                )
                            })}
                            {options!.length > 0 &&
                                <div className="c-form__group">
                                    <Select
                                        value={this.state.selectedOption}
                                        onChange={selectableOption => {
                                            if (selectableOption)
                                                this.handleSelect(selectableOption);
                                        }}
                                        options={options}
                                        className={"c-form__select"}
                                        classNamePrefix="c-select"
                                    />
                                    <button className='c-button c-form__control' onClick={(e) => this.addRole(e)}><Translator text="Add" /></button>
                                </div>
                            }
                            {!this.getEditUser() &&
                                <div className='c-form__group o-layout__item u-flex-1'>
                                    <button className='c-button' type='submit'><Translator text="Save" /></button>
                                </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        users: state.users,
        roles: state.roles,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        changePasswordModal: bindActionCreators(ModalActions.showModal, dispatch),
        // changePasswordAction: bindActionCreators(UserActions.changePassword, dispatch),
        addRole: bindActionCreators(UserActions.addRole, dispatch),
        removeRole: bindActionCreators(UserActions.removeRole, dispatch),
        fetchRoles: bindActionCreators(RoleActions.fetchRoles, dispatch),
        fetchUsers: bindActionCreators(UserActions.fetchAllUserData, dispatch),
        addUser: bindActionCreators(UserActions.addUser, dispatch),
    };
}
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountDetailsComp));